import { Component } from '@angular/core';
import { DeviceDTO } from 'src/app/models/DeviceDTO.model';
import { revertTransferDto } from 'src/app/models/inventory/revertTransferDto';
import { PlanAvailableDTO } from 'src/app/models/PlanAvailableDTO.model';
import { PlanDeviceDTO } from 'src/app/models/PlanDeviceDTO.model';
import { ResponseBase } from 'src/app/models/ResponseBase';
import { TableColumn } from 'src/app/models/TableColumn';
import { UnassignedCustomerDeviceDto } from 'src/app/models/UnassignedCustomerDeviceDto';
import { UserDTO } from 'src/app/models/UserDTO.model';
import { CustomerService } from 'src/app/services/customer.service';
import { InventoryService } from 'src/app/services/inventory.service';
import { DropdownItem } from 'src/app/shared/controls/dropdown-control/dropdown-control.component';
import { AlertService } from 'src/app/shared/services/alert.service';

import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DropdownControlComponent } from '../../../shared/controls/dropdown-control/dropdown-control.component';
import { TableControlComponent } from '../../../shared/controls/table-control/table-control.component';
declare var bootstrap: any;

@Component({
    selector: 'app-inventory-device-revert-transfer',
    templateUrl: './inventory-device-revert-transfer.component.html',
    styleUrl: './inventory-device-revert-transfer.component.css',
    imports: [
        CommonModule,
        RouterModule,
        DropdownControlComponent,
        TableControlComponent
    ]
})
export class InventoryDeviceRevertTransferComponent {
  currentStep = 0;
  steps = [
    { label: 'Source', valid: false },
    { label: 'Devices to Revert', valid: false },

    { label: 'Review', valid: false }
  ];



  devices: DeviceDTO[] = [];
  devicesList: UnassignedCustomerDeviceDto[] = [];
  customers: UserDTO[] = [];
  customersDropdownList: DropdownItem[] = [];
  plansAvailables: PlanAvailableDTO[] = [];
  userPlansList: DropdownItem[] = [];
  clearSelection: boolean = false;


  selectedDevices: DeviceDTO[] = [];

  disableCompleteTransferButton: boolean = false;

  columns: TableColumn[] = [
    { key: 'iccid', header: 'ICCID' },
    { key: 'imei', header: 'IMEI' },
    { key: 'firstName', header: 'Last Name' },
    { key: 'lastName', header: 'First Name' },
    { key: 'idAssignedTo', header: 'Assigned To' },
    { key: 'nameStatus', header: 'Status' }
  ]

  selectedCustomer: string | null = null;
  selectedUserPlan: string | null = null;



  /**
   *
   */
  constructor(private customerService: CustomerService, private inventoryService: InventoryService, private alertService: AlertService,) {


  }

  ngOnInit() {

    this.loadData();


  }

  loadData() {
    this.loadCustomersDevicesTransfers();

    this.inventoryService.getListPlansAvailables().subscribe(
      (response: PlanAvailableDTO[]) => {
        this.plansAvailables = response;
        this.userPlansList = this.plansAvailables.map(plan => ({
          key: plan.userPlanId !== undefined && plan.userPlanId !== null ? plan.userPlanId.toString() : '',
          value: `${plan.nameCustomer} - ${plan.namePlan}`,
        }));
      },
      (error) => {

      }
    );


  }

  loadCustomersDevicesTransfers() {
    this.customerService.GetCustomersWithTranfers().subscribe(
      (response: revertTransferDto) => {
        
        this.customers = response.customers || [];


        this.devicesList = response.devices || [];

        this.devices = this.devicesList.filter(item => {
          return item.userId === parseInt(this.selectedCustomer as string);
        }).map(item => ({ ...item.device })) || [];

        if (this.customersDropdownList.length === 0) {
          this.customersDropdownList = (response.customers ?? []).map(customer => ({
            key: customer.userId !== undefined && customer.userId !== null ? customer.userId.toString() : '',
            value: customer.userNames,
          }));
        }

      },
      (error) => {
        this.alertService.error('Error loading customers for transfer');
      }
    );

  }

  loadUserPlanActiveDevices(userPlanId: string) {
    this.customerService.GetUserPlanActiveDevices(userPlanId).subscribe(
      (response: DeviceDTO[]) => {
        
        this.devices = response;

      },
      (error) => {
        this.alertService.error('Error loading customers for transfer');
      }
    );

  }


  onSelectionChange(selectedDevices: DeviceDTO[]): void {

    this.selectedDevices = selectedDevices;
  }

  onTransferDevices() {
    const transferDeviceModal = new bootstrap.Modal("#transferDeviceModal");
    transferDeviceModal.show();
  }

  transferDeviceModalClose() {
    const transferDeviceModal = new bootstrap.Modal("#transferDeviceModal");
    transferDeviceModal.hide();
  }

  transferDevices() {


    this.disableCompleteTransferButton = true;


    if (this.selectedCustomer) {
      var request: UnassignedCustomerDeviceDto[] = this.selectedDevices.map(device => {
        return {

          userId: this.selectedCustomer ? parseInt(this.selectedCustomer) : null,
          deviceId: device.deviceId!,

        } as UnassignedCustomerDeviceDto;
      });


     
      
        this.inventoryService.revertDedviceTransferFromCustomer(request).subscribe(
          (data: ResponseBase) => {
            this.clearSteper();
            this.alertService.success('Devices transferr rollback successfully');

          },
          (error: any) => {
            this.alertService.error('Error reverting devices transfer');
          }
        );
      


    }
    else {
       if (this.selectedUserPlan) {

         var request2: any = {
           devices: this.selectedDevices.map(device => device.iccid),
           userPlanId: this.selectedUserPlan ? parseInt(this.selectedUserPlan) : null
         } as any;

        this.inventoryService.revertDedviceTransferFromUserPlan(request2).subscribe(
          (data: ResponseBase) => {
            this.clearSteper();
            this.alertService.success('Devices transferr rollback successfully');

          },
          (error: any) => {
            this.alertService.error('Error reverting devices transfer');
          }
        );
      }
    }
    const transferDeviceModal = new bootstrap.Modal("#transferDeviceModal");
    transferDeviceModal.hide();
  }

  get reviewInfoMessage() {




    if (this.selectedCustomer) {

      var customer = this.customers.find(c => c.userId === parseInt(this.selectedCustomer as string));

      return `for the customer: ${customer?.userNames}`;


    }



    return '';
  }

  clearSteper() {
    this.loadData();

    this.selectedCustomer = null;
    this.selectedUserPlan = null;
    this.selectedDevices = [];
    this.currentStep = 0;



    this.clearSelection = true;
    setTimeout(() => this.clearSelection = false);
  }

  onCustomerChange(event: any) {

    this.selectedCustomer = event.key;
    this.selectedUserPlan = null;


    if (this.selectedCustomer !== null) {
      this.loadCustomersDevicesTransfers();
    }

    this.isCurrentStepValid();
  }



  onUserPlanChange(event: any) {

    this.selectedUserPlan = event.key;
    this.selectedCustomer = null;

    if (this.selectedUserPlan !== null) {

      this.loadUserPlanActiveDevices(this.selectedUserPlan)
    }

    this.isCurrentStepValid();

  }


  get progressPercentage(): number {
    return (this.currentStep / (this.steps.length - 1)) * 100;
  }

  nextStep(): void {
    if (this.isCurrentStepValid()) {
      this.steps[this.currentStep].valid = true;
      this.currentStep++;
    }
  }

  previousStep(): void {
    this.currentStep--;
  }

  isCurrentStepValid(): boolean {
    switch (this.currentStep) {
      case 0:
        if (this.selectedCustomer || this.selectedUserPlan) {
          return true;
        }
        return false;

      case 1:
        return this.selectedDevices.length > 0;
      default:
        return true;
    }
  }
}
